import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { emit, text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<div class="slex-slider-field"><div class="slex-slider-label"><span class="slex-slider-label-text"><!> <span> </span></span> <span class="slex-slider-value"> <!></span></div> <div class="slex-slider-control"><span class="slex-slider-track" aria-hidden="true"></span> <input type="range" class="slex-slider"/></div></div>`);

export default function Slider($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));
	let value = $.state(0);
	let lastHapticTick = $.state(null);

	$.user_effect(() => bindPropStore($$props.props, (next) => {
		$.set(p, next, true);
		$.set(value, next.value ?? 0, true);
	}));

	function choose(next) {
		$.set(value, next, true);
		vibrateStep(next);
		emit($$props.ctx, "change", next);
	}

	function numberProp(input, fallback) {
		const next = Number(input ?? fallback);

		return Number.isFinite(next) ? next : fallback;
	}

	function sliderProgress(current, min, max) {
		const low = numberProp(min, 0);
		const high = numberProp(max, 100);
		const next = numberProp(current, low);

		if (high <= low) return "0%";

		const ratio = Math.min(1, Math.max(0, (next - low) / (high - low)));

		return `${Math.round(ratio * 10000) / 100}%`;
	}

	function stepSize() {
		const step = numberProp($.get(p).step, 1);

		return step > 0 ? step : 1;
	}

	function tickCount() {
		const low = numberProp($.get(p).min, 0);
		const high = numberProp($.get(p).max, 100);

		if (high <= low) return 0;

		return Math.round((high - low) / stepSize());
	}

	function tickIndex(current) {
		const low = numberProp($.get(p).min, 0);

		return Math.round((numberProp(current, low) - low) / stepSize());
	}

	function vibrate(duration = 8) {
		if ($.get(p).haptic === false || $.get(p).haptics === false) return;

		const api = globalThis.navigator;

		api?.vibrate?.(duration);
	}

	function grabSlider() {
		$.set(lastHapticTick, tickIndex($.get(value)), true);
		vibrate(8);
	}

	function vibrateStep(next) {
		if (tickCount() > 20) return;

		const tick = tickIndex(next);

		if (tick === $.get(lastHapticTick)) return;

		$.set(lastHapticTick, tick, true);
		vibrate(5);
	}

	var div = root();
	var div_1 = $.child(div);
	var span = $.child(div_1);
	var node = $.child(span);

	{
		var consequent = ($$anchor) => {
			InlineIcon($$anchor, {
				get name() {
					return $.get(p).icon;
				},
				className: 'slex-slider-icon'
			});
		};

		$.if(node, ($$render) => {
			if ($.get(p).icon) $$render(consequent);
		});
	}

	var span_1 = $.sibling(node, 2);
	var text_1 = $.child(span_1, true);

	$.reset(span_1);
	$.reset(span);

	var span_2 = $.sibling(span, 2);
	var text_2 = $.child(span_2, true);
	var node_1 = $.sibling(text_2);

	{
		var consequent_1 = ($$anchor) => {
			var text_3 = $.text();

			$.template_effect(($0) => $.set_text(text_3, $0), [() => text($.get(p).unit)]);
			$.append($$anchor, text_3);
		};

		$.if(node_1, ($$render) => {
			if ($.get(p).unit) $$render(consequent_1);
		});
	}

	$.reset(span_2);
	$.reset(div_1);

	var div_2 = $.sibling(div_1, 2);
	var input_1 = $.sibling($.child(div_2), 2);

	$.remove_input_defaults(input_1);
	$.reset(div_2);
	$.reset(div);

	$.template_effect(
		($0, $1, $2, $3, $4, $5, $6, $7, $8) => {
			$.set_attribute(div, 'data-orientation', $0);
			$.set_text(text_1, $1);
			$.set_text(text_2, $2);
			$.set_style(div_2, $3);
			$.set_attribute(input_1, 'min', $4);
			$.set_attribute(input_1, 'max', $5);
			$.set_attribute(input_1, 'step', $6);
			$.set_value(input_1, $7);
			input_1.disabled = !!$.get(p).disabled;
			$.set_attribute(input_1, 'aria-label', $8);
		},
		[
			() => text($.get(p).orientation, "horizontal"),
			() => text($.get(p).label ?? $$props.componentName),
			() => text($.get(value) ?? 0),
			() => `--slex-slider-progress: ${sliderProgress($.get(value), $.get(p).min, $.get(p).max)}`,
			() => Number($.get(p).min ?? 0),
			() => Number($.get(p).max ?? 100),
			() => Number($.get(p).step ?? 1),
			() => Number($.get(value) ?? 0),
			() => text($.get(p)["aria-label"] ?? $.get(p).ariaLabel ?? $.get(p).label ?? $$props.componentName)
		]
	);

	$.delegated('pointerdown', input_1, grabSlider);
	$.delegated('input', input_1, (event) => choose(Number(event.target.value)));
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['pointerdown', 'input']);